import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

export function useFetchRemittancePayers(
  isAuthenticated,
  email,
  currentOrganization,
  currentOrganizationType,
  currentRoute
) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchRemittancePayersKey";

  async function GetRemittancePayers() {
    const accessToken = oktaAuth.getAccessToken();

    let parameters = {
      email: email,
      selectedItem: currentOrganization,
      organizationType: currentOrganizationType,
    };

    var result = await axios
      .get("api/UserProgram/GetRemittancePayersWithRecentActivity", {
        params: parameters,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          RequestSrc: currentRoute,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  function IsEnabled() {
    if (!isAuthenticated) return false;
    if (IsNullOrEmpty(email)) return false;
    if (IsNullOrEmpty(currentOrganization)) return false;
    return true;
  }

  return useQuery({
    queryKey: [dataKey, [email, currentOrganization, currentRoute]],
    queryFn: async () => await GetRemittancePayers(),
    enabled: IsEnabled(),
    staleTime: 3 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchInterval: 1000 * 60 * 2,
  });
}
